import { FC, useEffect } from 'react'
import { useRouter } from 'next/router'
import { API } from 'project/api'
import { NextPageWithLayout } from '../../../types/nextPageWithLayout'
import { Project } from 'common/project'
import isWithoutNav, { shouldDisableTracking } from 'project/isWithoutNav'

type ComponentType = {
  Component: NextPageWithLayout
}

const AnalyticsContainer: FC<ComponentType> = ({ Component }) => {
  const router = useRouter()
  const trackPage = () => {
    if (!shouldDisableTracking()) {
      API.trackPage()
    }
  }
  const handleRouteChange = async () => {
    if (!shouldDisableTracking()) {
      const properties = await (Component.getAnalyticsProperties
        ? Component.getAnalyticsProperties()
        : Promise.resolve({}))
      trackPage()
    }
  }
  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      Project.gtm &&
      !isWithoutNav() &&
      !shouldDisableTracking()
    ) {
      // @ts-ignore
      trackPage() // track initial page
    }
  }, [])
  useEffect(() => {
    router.events.on('routeChangeComplete', handleRouteChange)
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [router.events])

  return <></>
}

export default AnalyticsContainer
